/* eslint-disable consistent-return */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Content, Blur } from '../../styles/components';
import Header from '../../components/Home/Header';
import Navbar from '../../components/Home/NavBar';
import { TitleSection, GridContainer } from './styles';
import Footer from '../../components/Home/Footer';
import ContactSection from '../../components/ContactSection';

const FaleConosco: React.FC = () => {
  const [focus, setFocus] = useState(false);
  const contactRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('focus') === 'true') {
      setFocus(true);
    }
  }, [location]);

  useEffect(() => {
    if (focus && contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const timer = setTimeout(() => setFocus(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [focus]);

  return (
    <>
      <Container>
        <Content>
          <Header />
        </Content>
      </Container>
      <Container backgroundImage className="companies-container">
        <Blur>
          <Content>
            <Navbar />
            <TitleSection>
              <h1>Entre em Contato</h1>
            </TitleSection>
          </Content>
        </Blur>
      </Container>
      <Container>
        <Content>
          <GridContainer>
            <div ref={contactRef}>
              <ContactSection hasFocus={focus} />
            </div>
          </GridContainer>
        </Content>
      </Container>
      <Container>
        <Footer
          giveFocus={hasClosed => {
            if (hasClosed) {
              setFocus(true);
            }
          }}
        />
      </Container>
    </>
  );
};

export default FaleConosco;
